// Function to help determine width of the browser window (i.e. media queries)
/* eslint-diable */
export default function getWidth() {
  const widthSources = [
    window.innerWidth,
    document.body.offsetWidth,
    document.body.clientWidth,
    document.documentElement.scrollWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth,
  ];
  return Math.max(...widthSources);
}
